import { Button, EmptyState } from '@mgrvtechgroup/admin-ds';
import { CompassIcon } from 'lucide-react';
import { Link } from 'react-router';

export function NotFoundPage() {
  return (
    <div className="flex h-full flex-col items-center justify-center gap-4">
      <h1 className="title-lg text-center">페이지를 찾을 수 없습니다</h1>
      <EmptyState
        icon={CompassIcon}
        title="주소를 다시 확인해 주세요"
        description="주소가 바뀌었거나 없어진 화면입니다. 아래 버튼으로 지점 목록에 돌아갈 수 있습니다."
        className="h-auto min-h-0 flex-none"
      />
      <Button nativeButton={false} role="link" render={<Link to="/" />}>
        지점 목록으로
      </Button>
    </div>
  );
}
